import reducer, { initialState, CreatorbaseCurrencyContextActions, CreatorbaseCurrencyContextState } from './reducer';
import React, { createContext, Dispatch, useCallback, useReducer } from 'react';
import useAbortableEffect from '../../Hooks/useAbortableEffect';
import { FCWithChildren } from '../../utility/utility.types';
import { getAllCurrencies } from '@round/api';

type CreatorbaseCurrencyContextValues = CreatorbaseCurrencyContextState;

export const CreatorbaseCurrencyContext = createContext<CreatorbaseCurrencyContextValues | null>(null);
export const CreatorbaseCurrencyDispatchContext = createContext<Dispatch<CreatorbaseCurrencyContextActions> | null>(
    null
);

type CreatorbaseCurrencyProviderProps = {
    children: React.ReactNode;
};

export const CreatorbaseCurrencyProvider: FCWithChildren<CreatorbaseCurrencyProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const fetchCurrencies = useCallback(async (requestInit?: RequestInit) => {
        try {
            dispatch({ type: 'loadingStarted' });
            const currencies = await getAllCurrencies({ creatorbase_enabled: true }, requestInit);
            dispatch({ type: 'currenciesLoaded', payload: currencies });
        } catch (error) {
            dispatch({
                type: 'error',
                payload: error instanceof Error ? error.message : 'Failed to load creatorbase currencies',
            });
        }
    }, []);

    useAbortableEffect(
        (signal) => {
            fetchCurrencies({ signal });
        },
        [fetchCurrencies]
    );

    return (
        <CreatorbaseCurrencyContext.Provider value={state}>
            <CreatorbaseCurrencyDispatchContext.Provider value={dispatch}>
                {children}
            </CreatorbaseCurrencyDispatchContext.Provider>
        </CreatorbaseCurrencyContext.Provider>
    );
};
